export enum TrainingSectionType {
  Video = 'VIDEO_LINK',
  Pdf = 'FILE',
  Question = 'QUIZ',
};
